import ImagesMosaic from './ImagesMosaic'

export default ImagesMosaic